import User from './User'

/**
 * 用户关注的信息的配置
 * 
 * @author zhouwei
 * @since 2021-05-05
 */
export default class ConcernedInfo {
    id
    title
    includeWords
    excludeWords
    includeAreas
    excludeAreas
    includeCompany
    excludeCompany
    receiveDailyReport
    receiveStart
    startAsLong
    receiveEnd
    endAsLong
    creator
    createDate
    updator
    updateDate
    version

    constructor(props) {
        var pp = props || {}
        this.id = pp.id || ''
        this.title = pp.title || ''
        this.includeWords = pp.includeWords || ''
        this.excludeWords = pp.excludeWords || ''
        this.includeAreas = pp.includeAreas || ''
        this.excludeAreas = pp.excludeAreas || ''
        this.includeCompany = pp.includeCompany || ''
        this.excludeCompany = pp.excludeCompany || ''
        this.receiveDailyReport = !!pp.receiveDailyReport
        this.receiveStart = pp.receiveStart || null
        this.startAsLong = pp.startAsLong || null
        this.receiveEnd = pp.receiveEnd || null
        this.endAsLong = pp.endAsLong || null
        this.creator = new User(pp.creator)
        this.updator = new User(pp.updator)
        this.createDate = pp.createDate || null
        this.updateDate = pp.updateDate || null
        this.version = pp.version || 0
    }

}